// The routes that make up the auth flow.
//
// Two places key off this list and must never drift apart: the router guard
// (which must not remember one of these as the post-login destination) and the
// post-auth redirect stash (which is only live while the user is inside the
// flow, and is dropped the moment they leave it).
export const AUTH_ROUTES = ['login', 'signup', 'forgot-password', 'reset-password']
